import React, { useState, useEffect } from "react";

import axiosInstance from "../../config/axios";
import { toast } from "react-toastify";

const FacebooxPixelForm = () => {
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    fetchAdsenseData();
  }, []);

  const fetchAdsenseData = async () => {
    try {
      const result = await axiosInstance.get("api/admin/facebook-pixel-api/");
      if (result?.data && result?.data?.data?.pixel_key) {
        setApiKey(result?.data?.data?.pixel_key);

        toast.success(result?.data?.data?.msg);
        setIsUpdate(true);
      } else {
        toast.success(result?.data?.data?.msg);
        setIsUpdate(false);
      }
    } catch (err) {
      setError("Failed to fetch AdSense data.");
    }
  };

  const handleApiKeyChange = (e) => {
    setApiKey(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setResponse(null);

    try {
      const apiUrl = isUpdate
        ? `api/admin/facebook-pixel-api/`
        : "api/admin/facebook-pixel-api/";

      const method = isUpdate ? "post" : "post";

      const result = await axiosInstance[method](apiUrl, {
        pixel_key: apiKey,
      });

      //   console.log(result?.data?.msg);
      toast.success(result?.data?.msg);

      setResponse(result.data);
      fetchAdsenseData();
    } catch (err) {
      setError("An error occurred while submitting the AdSense data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[90vh] w-full flex items-center justify-center">
      <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-lg w-full">
        <h1 className="text-2xl font-bold text-center mb-6">
          {isUpdate ? "Update" : "Add"} Your API Key to Facebook Pixel
        </h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex flex-col">
            <label htmlFor="apiKey" className="text-lg font-medium mb-2">
              API Key
            </label>
            <input
              type="text"
              id="apiKey"
              name="apiKey"
              value={apiKey}
              onChange={handleApiKeyChange}
              placeholder="Enter your API Key"
              className="p-3 border border-gray-300 rounded-md text-lg"
              required
            />
          </div>

          <button
            type="submit"
            className={`w-full py-3 text-white font-semibold rounded-md transition-all duration-300 ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-orange-500 hover:bg-orange-600"
            }`}
            disabled={loading}
          >
            {loading ? "Loading..." : isUpdate ? "Update" : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FacebooxPixelForm;
